import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const RoleBasedAccess = ({ 
  children, 
  allowedRoles = [], 
  fallback = null,
  showForAdmin = true 
}) => {
  const { user, hasRole } = useAuth();

  // If no roles specified, show for everyone
  if (allowedRoles.length === 0) {
    return <>{children}</>;
  }

  // Check if user has any of the allowed roles
  const hasAccess = allowedRoles.some(role => hasRole(role)) || (showForAdmin && hasRole('ADMIN'));

  if (hasAccess) {
    return <>{children}</>;
  }

  return fallback ? <>{fallback}</> : null;
};

export default RoleBasedAccess;
